import * as React from 'react';

const SplitView = (props:any) => (
    <svg
        width={64}
        height={64}
        viewBox="0 0 64 64"
        xmlnsXlink="http://www.w3.org/2000/xlink"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <path d="M10 16v32h44V16H10z" stroke="#7B838C" strokeWidth="4" fill="#FFF"/>
            <path fill="#D2D5D8" d="M12 18h40v8H12z"/>
            <path d="M10 16v12h44V16H10zM10 28v20h12V28H10z" stroke="#7B838C" strokeWidth="4"/>
            <path fill="#D2D5D8" d="M12 30h8v16h-8z"/>
        </g>
    </svg>
);

export default SplitView;

